export const today = require("./dashboard_benefits_today.json");
export const yesterday = require("./dashboard_benefits_yesterday.json");
export const week = require("./dashboard_benefits_week.json");
export const month = require("./dashboard_benefits_month.json");
